module.exports = __webpack_public_path__ + "media/images/pc/stores/umeda/umeda_concept_02-a57ed320ef59b8da331aa43ca3ed2a92.jpg";